import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";

import * as request from "../util/request";
import { ReduxState } from "./reducers";
import {
    PortfolioTab,
    MessagesTab,
    NewsFeedTab,
} from "components/BottomBar/BottomBar";

export interface IConfirmBackNavigation {
    required: boolean;
    message: string;
    route?: string;
}

/**
 * Action factory + actions
 */
const actionFactory = actionCreatorFactory("HypoMobiili/Common");
export const SetHeader = actionFactory<string>("SET_HEADER");
export const ShowLogo = actionFactory<boolean>("TOGGLE_LOGO");
export const ShowDrawer = actionFactory<boolean>("TOGGLE_DRAWER");
export const ShowFeedback = actionFactory<boolean>("TOGGLE_FEEDBACK");
export const ShowBottomBar = actionFactory<boolean>("TOGGLE_BOTTOMBAR");
export const SetShowBackNavigation = actionFactory<boolean>(
    "TOGGLE_SHOW_BACK_NAVIGATION"
);
export const ShowBackNavigationWithRoute = actionFactory<string>(
    "TOGGLE_SHOW_BACK_NAVIGATION_WITH_ROUTE"
);
export const SetShowConfirmDialog = actionFactory<boolean>(
    "TOGGLE_SHOW_CONFIRM_DIALOG"
);
export const SetShowConfirmBackNavigation = actionFactory<
    IConfirmBackNavigation
>("TOGGLE_SHOW_CONFIRM_BACK_NAVIGATION");
export const SetBottomBarTab = actionFactory<number | undefined>(
    "SET_BOTTOM_BAR_TAB"
);

/**
 * The internal state of this reducer
 */
export class CommonState {
    header: string;
    showLogo: boolean;
    showDrawer: boolean;
    showFeedback: boolean;
    showFeedbackFeature: boolean;
    showBottomBar: boolean;
    confirmBackNavigation: IConfirmBackNavigation;
    showBackButton: boolean;
    showBackButtonConfirm: boolean;
    backButtonRoute?: string;
    bottomBarTab: number;
}

const getInitialConfirmNavigation = (): IConfirmBackNavigation => ({
    required: false,
    message: "",
});

/**
 * The reducer.
 *
 * The module exports this as default
 */

const initialCommonState: CommonState = {
    header: "Mobiilipankki",
    showLogo: true,
    showDrawer: false,
    showFeedback: false,
    showFeedbackFeature: false,
    showBottomBar: true,
    confirmBackNavigation: getInitialConfirmNavigation(),
    showBackButton: false,
    showBackButtonConfirm: false,
    bottomBarTab: PortfolioTab,
};

export const CommonReducer = reducerWithInitialState(initialCommonState)
    .case(SetHeader, (state, action) => {
        return {
            ...state,
            header: action.payload,
        };
    })
    .case(ShowLogo, (state, action) => {
        return {
            ...state,
            showLogo: action.payload,
        };
    })
    .case(ShowDrawer, (state, action) => {
        return {
            ...state,
            showDrawer: action.payload,
        };
    })
    .case(ShowFeedback, (state, action) => {
        return {
            ...state,
            showFeedback: action.payload,
        };
    })
    .case(ShowBottomBar, (state, action) => {
        return {
            ...state,
            showBottomBar: action.payload,
        };
    })
    .case(SetShowBackNavigation, (state, action) => {
        return {
            ...state,
            showBackButton: action.payload.valueOf(),
            backButtonRoute: undefined,
            confirmBackNavigation: getInitialConfirmNavigation(),
        };
    })
    .case(ShowBackNavigationWithRoute, (state, action) => {
        return {
            ...state,
            showBackButton: true,
            backButtonRoute: action.payload,
            confirmBackNavigation: getInitialConfirmNavigation(),
        };
    })
    .case(SetShowConfirmDialog, (state, action) => {
        return {
            ...state,
            showBackButtonConfirm: action.payload.valueOf(),
        };
    })
    .case(SetShowConfirmBackNavigation, (state, action) => {
        return {
            ...state,
            showBackButton: action.payload.required,
            backButtonRoute: action.payload.route || "",
            confirmBackNavigation: action.payload,
        };
    })
    .case(SetBottomBarTab, (state, action) => {
        return {
            ...state,
            bottomBarTab: action.payload || PortfolioTab,
        };
    });

export default CommonReducer;

/**
 * Selectors
 */
export const showBackButton = (state: ReduxState): boolean => {
    return (state && state.common && state.common.showBackButton) || false;
};

export const getBackButtonRoute = (state: ReduxState): string | undefined => {
    return (state && state.common && state.common.backButtonRoute) || undefined;
};

export const getBackButtonConfirmInfo = (state: ReduxState) => {
    return (
        (state && state.common && state.common.confirmBackNavigation) ||
        undefined
    );
};

export const showConfirmDialog = (state: ReduxState) => {
    return (
        (state && state.common && state.common.showBackButtonConfirm) || false
    );
};

export const getBottomBarTab = (state: ReduxState) => {
    return (state && state.common && state.common.bottomBarTab) || 0;
};



// WEBPACK FOOTER //
// ./src/ducks/common.ts